// angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { AuthenticationService } from '../../core/services/authentication.service';
import { PasswordResetService } from '../../core/services/password-reset.service';
//
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-recover',
    templateUrl: './recover.component.html',
    styleUrls: ['./recover.component.css']
})
export class RecoverComponent implements OnInit, OnDestroy {

    form: FormGroup;
    requestError: Boolean;
    requestProcessing: Boolean;
    private subscription_auth;


    bodyClasses = 'login';
    body: HTMLBodyElement = document.getElementsByTagName('body')[0];

    username: string;


    constructor(private fb: FormBuilder,
        private auth: AuthenticationService,
        private router: Router,
        private translateService: TranslateService,
        private passwordResetService: PasswordResetService,
        private toastr: ToastrService
    ) { }

    ngOnInit() {
        this.requestProcessing = false;
        this.requestError = false;
        this.form = this.fb.group({
            userName: ['', Validators.required]
        });

        // add the the body classes
        this.body.classList.add('login');
        // Borramos todo por si acaso.... algo
        this.auth.logout(undefined, true);
        localStorage.removeItem('currentUser');
    }

    recuperar() {
        if (this.form.valid) {
            this.username = this.form.get('userName').value;

            this.requestProcessing = true;

            // -*-*-*--*Integración recuperación contraseña

            this.requestProcessing = true;
            this.requestError = false;
            this.passwordResetService.requestPasswordReset(this.username).subscribe(
                (result: any) => {
                    this.requestError = false;
                    this.requestProcessing = false;
                    const msg = result && result.error ? result.error : 'EMAIL_SENDED';
                    this.showMessage(msg);
                },
                error => {
                    this.requestError = true;
                    this.requestProcessing = false;
                    const msg = error.status != 500 ? error.error.Message : 'NOT_EMAIL_SENDED';
                    this.showMessage(msg);
                }
            );
            // this.subscription_auth = this.auth.recuperar(this.username)// (7)
            //    .subscribe(
            //        result => {
            //            console.log(result);
            //            this.requestError = false;
            //            this.requestProcessing = false;

            //            // si el result es true callout --> contrase�a enviada al email bla bla bla
            //            //si el result es false callout --> no se ha podido recuperar su contrase�a bla bla bla
            //        },
            //        error => {
            //            this.requestError = true; // error generico e inmutable del server
            //            this.requestProcessing = false;
            //        }

            //    );

        }
    }
    private showMessage(msg: string) {
        this.toastr.warning(this.translateService.instant(`errorsKeys.${msg}`));
    }

    backLogin() {
        this.router.navigate(['/login']);
    }

    isFieldInvalid(field: string) {// (6)
        return (
            (!this.form.get(field).valid && this.form.get(field).touched) ||
            (this.form.get(field).untouched && this.requestProcessing)
        );
    }

    ngOnDestroy() {
        this.fb = null;
        this.auth = null;
        this.router = null;
        this.translateService = null;
        // this.subscription_auth = null;

    }
}
